import { useState } from "react";
import { faqItems } from "@/mocks/fanCommunity";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[340px_1fr] lg:gap-12">
          {/* left */}
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-question-line" />
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold tracking-tight text-foreground-950">
              有疑问？这里先看
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              关于超话、后援会、周边与见面会的常见疑问，为你集中解答。
            </p>
            <div className="mt-6 rounded-xl border border-background-200 bg-background-100 p-5">
              <p className="text-sm font-medium text-foreground-800">仍没有解答你的问题？</p>
              <p className="mt-1.5 text-sm text-foreground-600">应援、合作与反馈请邮件联系工作人员。</p>
              <a
                href="mailto:fanclub@chiguajieke.cn"
                className="mt-4 inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-secondary-500 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-secondary-600"
              >
                <i className="ri-mail-line" />
                fanclub@chiguajieke.cn
              </a>
            </div>
          </div>

          {/* accordion */}
          <ul className="space-y-3">
            {faqItems.map((f, i) => {
              const open = openIdx === i;
              return (
                <li
                  key={f.q}
                  className={`overflow-hidden rounded-xl border transition-colors ${
                    open ? "border-primary-200 bg-background-100" : "border-background-200 bg-background-100/60"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                      {f.q}
                    </h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-transform duration-300 ${
                        open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className="ri-add-line" />
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm md:text-base leading-relaxed text-foreground-600">{f.a}</p>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}